module.exports = {
    junior: require('./junior')
};
